module.exports = __webpack_public_path__ + "img/1.8c3af32f.png";